/**
 * 输入语言检测服务
 * @description 检测用户输入的语言，是否符合中英文占比不低于50%的要求
 */
export interface InputLanguageDetectionService {
    /**
     * 检测用户输入的语言
     */
    detect(text: string): Promise<boolean>;
}

export const InputLanguageDetectionService = Symbol.for('InputLanguageDetectionService');
